module.exports = ".card-columns {\n  -webkit-column-count: 7;\n     -moz-column-count: 7;\n          column-count: 7;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/management.component.less
// module id = ./src/app/web/game/management/management.component.less
// module chunks = main